/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

const desktopBreakImages = () => {
    if($('.product-item').length >= 4){
        let count = 0;
        $('.product-item').each((idx, item) => {
            const insert = idx === 2 || count === 3 ? true : false;
            count ++;
            if(insert){
                if($('[data-desk-break-images] .desk-break-item').length){
                    $(item).after($('[data-desk-break-images] .desk-break-item').eq(0));
                }else{
                    return false;
                }
                count = 0;
            }
        })
    }
}

const mobileBreakPrhases = () => {
    if($('.product-item').length >= 3){
        let count = 0;
        $('.product-item').each((idx, item) => {
            const insert = count === 2 ? true : false;
            count ++;
            if(insert){
                if($('[data-mobile-phrases] .prhases-group').length){
                    $(item).after($('[data-mobile-phrases] .prhases-group').eq(0));
                }else{
                    return false;
                }
                count = 0;
            }
        })
        setTimeout(() => {
            $('.prhases-slide').each((idx, item) => {
                $(item).slick({
                    infinite: false,
                    arrows: false,
                    dots: true
                });
            })
        }, 500)
    }
}

const showInstallment = (total) => {
    const qtyParcel = 6;
    const price = Number(total / 100);
    const parcel = price / qtyParcel;
    const elParcels = document.querySelector('.totalParcels');
    if(elParcels){
        elParcels.innerHTML = `<strong>${qtyParcel}X de R$ ${parcel.toLocaleString('pt-BR', {minimumFractionDigits: 2,maximumFractionDigits: 2})}</strong> sem juros`
    }
}


let discountValue = 0;

 $( document ).ready(function() {
    let paginationCustom = $('.paginationCustom li').length;

    function formatReal( int ){
        var tmp = int+'';
        tmp = tmp.replace(/([0-9]{2})$/g, ",$1");
        if( tmp.length > 6 )
                tmp = tmp.replace(/([0-9]{3}),([0-9]{2}$)/g, ".$1,$2");
        return tmp;
    }

    function calcDiscount(price) {
        if(discountValue == 0 || price == 0){
            return price;
        }
        return price - (price * (discountValue / 100));
    }

    function formatDiscountPrice(add, price) {
        const plus = add ? '+' : '';
        if (discountValue == 0){
            return `${plus} R$ ${formatReal(price)}`
        }
        return `
            <del>R$ ${formatReal(price)}</del><br>
            <span>${plus} R$ ${formatReal(calcDiscount(price))}</span>
        `;
    }



    const custom = {

        activeStepAccordion(step) {
            const currentClass = `.footer-metafield.accordion-${step}`;
            $('.custom_buy').removeClass('with-accordion');
            if($('.footer-metafield')[0]){
                $('.footer-metafield').removeClass('active');
                $('.js-openImage').removeClass('is-active');
                $('.footer-metafield__paragraph').removeClass('is-active');
                if($(currentClass)[0]){
                    $(currentClass).addClass('active');
                    $('.custom_buy').addClass('with-accordion');
                }
            }
        },

        activeStepBar(step){

            if(step !== 1){
                const totalSteps = paginationCustom;
                const sizes = [];
                const stepSize = 100 / (totalSteps - 1);
                for (let i = 0; i < totalSteps; i++){
                    sizes.push(stepSize * i);
                }
                $('.paginationCustom .slide-bar').width(`${sizes[step - 1]}%`);
            }else{
                $('.paginationCustom .slide-bar').width(0);
            }

        },

        //fecha custom lentes
        closeCustomLens(){
            $('.btnCloseCustom').on("click", function() {
                $('.nem-imagem-modal').removeClass('is-active')
                $('.custom_buy').removeClass('active');
                $('body').removeClass('hidden-scroll');

                $('#shopify-section-announcement-bar').removeClass('is-hidden')
                $('#shopify-section-header').removeClass('is-hidden')

                $('shopify-section--announcement-bar').removeClass('custom-buy_active');
                $('.shopify-section--header').removeClass('custom-buy_active');
                $('#shopify-section-announcement-bar').removeClass('custom-buy_active');

                $('.custom_buy .step2, .custom_buy .step3, .custom_buy .step4').hide();
                $('.custom_buy .step1').show();
                custom.activeStepAccordion(1);
                $('.paginationCustom li').removeClass('active');
                $('.paginationCustom li').eq(0).addClass('active');
                custom.activeStepBar(1);

            });
        },

        //abre custom lentes
        openCustomLens(){
            if(document.querySelector('[name="custom-lens-discount"]')){
                discountValue = Number(document.querySelector('[name="custom-lens-discount"]').value);
            }

            $('.product-form .openCustom').on("click", function() {
                custom.openModalWihtImage();

                if(window.innerWidth < 600){
                    $("html, body").animate({ scrollTop: 0 }, "fast");
                }
                let variantId = parseInt($('.product-form input[name="id"]').val());
                $('.custom_buy').addClass('active');

                $('.btnAddCartCustom').attr('data-productid',variantId);
                $('.paginationCustom li').removeClass('active');
                $('.paginationCustom li:first-child').addClass('active');
                custom.activeStepBar(1);

                const productJson = JSON.parse($('[data-product-json]').html());
                const currentVariant = productJson.variants.find((x) => {return x.id == variantId});
                const currentPrice = currentVariant ? currentVariant.price : productJson.price;
                const nameProductVar = currentVariant ? currentVariant.name : pproductJson.title;
                $('.custom_buy').attr('data-price', currentPrice);
                //atualiza preço produto passo 3 ou 4
                if ( paginationCustom == 3 ) {
                    $('.step3 .productSelected .price').text('R$ ' + formatReal(currentPrice));
                    $('.step3 .productSelected .price').attr('data-price', currentPrice);

                } else if( paginationCustom == 4 ){
                    $('.step4 .productSelected .price').text('R$ ' + formatReal(currentPrice));
                    $('.step4 .productSelected .price').attr('data-price', currentPrice);
                }
                //atualiza texto passo 4
                $('.productSelected .choice').text(nameProductVar);

                /*let handleCurrent = $(this).attr('data-handle');
                $.getJSON('/products/'+handleCurrent+'.js', function(product) {
                    debugger;
                    for (let i = 0; i < product.variants.length; i++) {
                        if(variantId == product.variants[i].id){
                            let price = product.variants[i].price;
                            $('.custom_buy').attr('data-price', price);

                            //atualiza preço produto passo 3 ou 4
                            if ( paginationCustom == 3 ) {
                                $('.step3 .productSelected .price').text('R$ ' + formatReal(price));
                                $('.step3 .productSelected .price').attr('data-price', price);

                            } else if( paginationCustom == 4 ){
                                $('.step4 .productSelected .price').text('R$ ' + formatReal(price));
                                $('.step4 .productSelected .price').attr('data-price', price);

                            }

                            //atualiza texto passo 4
                            const nameProductVar = product.variants[i].name;
                            $('.productSelected .choice').text(nameProductVar)
                        }
                    }
                });*/
                return false;
            });
        },

        //pega os preços das customizações
        getPriceHandle(){
            $('.custom_buy .priceCustom').each(function() {
                let thisCurrent = $(this);


                if(thisCurrent.attr('data-handle') == ''){

                    //add preço gratis sem handle
                    thisCurrent.text('Grátis')
                    thisCurrent.attr('data-variantid', '')
                }else{

                    //add preço e variantID à partir do handle cadastrado
                    // const productJsonLoad = JSON.parse($('[data-product-json]').html());
                    // if(productJsonLoad.price > 0){
                    //     thisCurrent.text('+ R$ ' + formatReal(productJsonLoad.price))
                    // }else{
                    //     thisCurrent.text('Grátis');
                    // }
                    // thisCurrent.attr('data-variantid', productJsonLoad.variants[0].id)
                    // thisCurrent.attr('data-price', productJsonLoad.price)

                    let handleCurrent = thisCurrent.attr('data-handle');
                    $.getJSON('/products/'+handleCurrent+'.js', function(product) {

                        if(product.price > 0){
                            const currentStep = Number(thisCurrent.attr('data-step'));
                            const showDiscount = currentStep === 2 || currentStep === 3 ? true : false;
                            const showPlus = currentStep === 3 ? true : false;
                            if(discountValue === 0 || !showDiscount){
                                thisCurrent.text(`${showPlus ? '+' : ''} R$ ${formatReal(product.price)}`)
                            }else{
                                thisCurrent.html(formatDiscountPrice(showPlus, product.price))
                            }
                        }else{
                            thisCurrent.text('Grátis');
                        }
                        thisCurrent.attr('data-variantid', product.variants[0].id)
                        thisCurrent.attr('data-price', product.price)
                    });
                }
            });
        },
        calcTotalPrice(paginationCustom){

            let productVariantPrice = 0;
            let step1Price = 0;
            let step2Price = 0;
            let totalPrice = 0;
            let step2Discount = 0;
            let step3Discount = 0;
            let totalDiscountPrice = 0;

            if(paginationCustom == 0) {
                const currentClass = $('.step4')[0] ? '.step4' : '.step3'
                productVariantPrice = parseInt($(`${currentClass} .productSelected .price`).attr('data-price'));
                totalPrice = productVariantPrice;
                $(`${currentClass} .totalPrice .value`).html('R$ ' + formatReal(totalPrice));
                showInstallment(totalPrice);
            }else if(paginationCustom == 2){
                const currentClass = $('.step4')[0] ? '.step4' : '.step3'
                productVariantPrice = parseInt($(`${currentClass} .productSelected .price`).attr('data-price'));
                step1Price = parseInt($(`.custom_buy ${currentClass} .step1Selected .price`).attr('data-price'));
                totalPrice = productVariantPrice + step1Price;
                $(`${currentClass} .totalPrice .value`).text('R$ ' + formatReal(totalPrice));
                showInstallment(totalPrice);
            }else if( paginationCustom == 3 ){
                //soma passo 3
                productVariantPrice = parseInt($('.step3 .productSelected .price').attr('data-price'));
                step1Price = parseInt($('.custom_buy .step3 .step1Selected .price').attr('data-price'));
                step2Price = parseInt($('.custom_buy .step3 .step2Selected .price').attr('data-price'));
                step2Discount = calcDiscount(step2Price);
                totalDiscountPrice = productVariantPrice + step1Price + step2Discount;
                totalPrice = productVariantPrice + step1Price + step2Price;
                if(totalDiscountPrice == totalPrice){
                    $('.step3 .totalPrice .value').text('R$ ' + formatReal(totalPrice));
                }else{
                    $('.step3 .totalPrice .value').html(`
                        <del>R$ ${formatReal(totalPrice)}</del><br>
                        <span>R$ ${formatReal(totalDiscountPrice)}</span>
                    `);
                }
                showInstallment(totalDiscountPrice);
            } else if( paginationCustom == 4 ){
                //soma passo 4
                productVariantPrice = parseInt($('.step4 .productSelected .price').attr('data-price'));
                step1Price = parseInt($('.custom_buy .step4 .step1Selected .price').attr('data-price'));
                step2Price = parseInt($('.custom_buy .step4 .step2Selected .price').attr('data-price'));
                step2Discount = calcDiscount(step2Price);
                step3Price = parseInt($('.custom_buy .step4 .step3Selected .price').attr('data-price'));
                step3Discount = calcDiscount(step3Price);
                totalDiscountPrice = productVariantPrice + step1Price + step2Discount + step3Discount;
                totalPrice = productVariantPrice + step1Price + step2Price + step3Price;
                if(totalDiscountPrice == totalPrice){
                    $('.step4 .totalPrice .value').text('R$ ' + formatReal(totalPrice));
                }else{
                    $('.step4 .totalPrice .value').html(`
                        <del>R$ ${formatReal(totalPrice)}</del><br>
                        <span>R$ ${formatReal(totalDiscountPrice)}</span>
                    `);
                }
                showInstallment(totalDiscountPrice);
            }
        },
        selectCustom(){
            //Passo 1
            $('.contentStep1').on("click", function() {
                const isOnlyFrame = $(this).hasClass('only-frames');
                let isEndQuiz = $(this).attr('data-end-quiz') == 'true' || isOnlyFrame ? true : false;
                if(isEndQuiz){
                    const hasStep4 = $('.step4')[0] ? true : false;
                    const endStepClass = hasStep4 ? '.step4' : '.step3';
                    const endStepNumber = hasStep4 ? '4' : '3';

                    $('.step1').hide();
                    $(endStepClass).show().addClass('active');
                    custom.activeStepAccordion(endStepNumber);

                    $('a.btnBack').addClass('is-hidden')
                    $('a.backToStep1').removeClass('is-hidden');

                    let priceStep1 = isOnlyFrame ? 0 : $(this).find('.priceCustom').attr('data-price');
                    if(priceStep1 != ''){
                        $(`.custom_buy ${endStepClass} .step1Selected .price`).text('R$ ' + formatReal(parseInt(priceStep1)));
                        $(`.custom_buy ${endStepClass} .step1Selected .price`).attr('data-price', priceStep1);
                    }else{
                        $(`.custom_buy ${endStepClass} .step1Selected .price`).text('Grátis');
                        $(`.custom_buy ${endStepClass} .step1Selected .price`).attr('data-price', 0);
                    }

                    const textClick = $(this).find('.text_button').text().trim();
                    $('.step1Selected .choice').text(textClick);

                    $('.step2Selected, .step3Selected').hide();

                    paginationCustom = 2;
                    custom.activeStepBar(2);
                    $('.btnAddCartCustom').attr('data-step1id',  '')
                    $('.btnAddCartCustom').attr('data-step1prop',  '')
                    $('.btnAddCartCustom').attr('data-step2prop', '');
                    if($('.btnAddCartCustom').attr('data-step3prop')){
                        $('.btnAddCartCustom').attr('data-step3prop', '');
                    }
                    if(isOnlyFrame){
                        $('.step1Selected').hide();
                        paginationCustom = 0;
                        custom.calcTotalPrice(0);
                    }else{
                        $('.btnAddCartCustom').attr('data-step1id',  $(this).find('.priceCustom').attr('data-variantid'))
                        $('.btnAddCartCustom').attr('data-step1prop',  $(this).find('.text_button').text().trim())
                        $('.step1Selected').show();
                        custom.calcTotalPrice(2);
                    }

                }else{
                    paginationCustom = $('.paginationCustom li').length;
                    $('.step2Selected, .step3Selected').show();
                    //remove Class hide passo 2
                    $('.contentStep2').removeClass('hide');

                    $('a.btnBack').addClass('is-hidden')
                    $('a.backToStep1').removeClass('is-hidden');


                    //atualiza preço passo 3
                    let priceStep1 = $(this).find('.priceCustom').attr('data-price');
                    if(priceStep1 != ''){
                        if( paginationCustom == 3 ){
                            $('.custom_buy .step3 .step1Selected .price').text('R$ ' + formatReal(parseInt(priceStep1)));
                            $('.custom_buy .step3 .step1Selected .price').attr('data-price', priceStep1);
                        } else if( paginationCustom == 4 ){
                            $('.custom_buy .step4 .step1Selected .price').text('R$ ' + formatReal(parseInt(priceStep1)));
                            $('.custom_buy .step4 .step1Selected .price').attr('data-price', priceStep1);
                        }
                    }else{
                        if( paginationCustom == 3 ){
                            $('.custom_buy .step3 .step1Selected .price').text('Grátis');
                            $('.custom_buy .step3 .step1Selected .price').attr('data-price', 0);
                        } else if( paginationCustom == 4 ){
                            $('.custom_buy .step4 .step1Selected .price').text('Grátis');
                            $('.custom_buy .step4 .step1Selected .price').attr('data-price', 0);
                        }
                    }

                    //atualiza texto passo 3
                    const textClick = $(this).find('.text_button').text().trim();
                    $('.step1Selected .choice').text(textClick)

                    //avança passo 2
                    $(this).siblings('div').removeClass('active');
                    $(this).addClass('active');
                    $(this).parent().hide();
                    $('.custom_buy .step2').show();
                    custom.activeStepAccordion(2);
                    $('.custom_buy .step2').addClass('active');
                    // $('.paginationCustom li[data-slide="1"]').removeClass('active');
                    $('.paginationCustom li:nth-child(2)').addClass('active');
                    custom.activeStepBar(2);

                    //add variantID botão btnAddCartCustom
                    $('.btnAddCartCustom').attr('data-step1id',  $(this).find('.priceCustom').attr('data-variantid'))
                    $('.btnAddCartCustom').attr('data-step1prop',  $(this).find('.text_button').text().trim())

                    //salva escolha feita do passo1 no input do passo 2
                    let orderChose = parseInt($(this).attr('data-order')) + 1;
                    orderChose = orderChose.toString();
                    $('.contentStep2').each(function() {
                        let arrayChoose = $(this).find('.choose_step_1').val().trim().replaceAll(' ', '').split(',');
                        const arrayContains = (arrayChoose.indexOf(orderChose) > -1);
                        if(arrayContains){
                            $(this).addClass('hide');
                        }
                    });
                }
            });

            //  Passo 2
            $('.contentStep2').on("click", function() {
                //remove Class hide passo 2
                $('.contentStep3').removeClass('hide');

                $('a.btnBack').addClass('is-hidden')
                $('a.backToStep2').removeClass('is-hidden');


                //atualiza preço passo 3
                let priceStep2 = $(this).find('.priceCustom').attr('data-price');
                if(priceStep2 != ''){
                    if( paginationCustom == 3 ){
                        $('.custom_buy .step3 .step2Selected .price').html(formatDiscountPrice(false, Number(priceStep2)));
                        $('.custom_buy .step3 .step2Selected .price').attr('data-price', priceStep2);
                    } else if( paginationCustom == 4 ){
                        $('.custom_buy .step4 .step2Selected .price').html(formatDiscountPrice(false, Number(priceStep2)));
                        $('.custom_buy .step4 .step2Selected .price').attr('data-price', priceStep2);
                    }
                }else{
                    if( paginationCustom == 3 ){
                        $('.custom_buy .step3 .step2Selected .price').text('Grátis');
                        $('.custom_buy .step3 .step2Selected .price').attr('data-price', 0);
                    } else if( paginationCustom == 4 ){
                        $('.custom_buy .step4 .step2Selected .price').text('Grátis');
                        $('.custom_buy .step4 .step2Selected .price').attr('data-price', 0);
                    }
                }

                //atualiza texto passo 3
                const textClick = $(this).find('.text_button').text().trim();
                $('.step2Selected .choice').text(textClick)

                //avança passo 2
                $(this).siblings('div').removeClass('active');
                $(this).addClass('active');
                $(this).parent().hide();
                $('.custom_buy .step3').show();
                custom.activeStepAccordion(3);
                $('.custom_buy .step3').addClass('active');
                // $('.paginationCustom li[data-slide="2"]').removeClass('active');
                $('.paginationCustom li:nth-child(3)').addClass('active');
                custom.activeStepBar(3);

                //add variantID botão btnAddCartCustom
                $('.btnAddCartCustom').attr('data-step2id',  $(this).find('.priceCustom').attr('data-variantid'))
                $('.btnAddCartCustom').attr('data-step2prop',  $(this).find('.text_button').text().trim())

                //salva escolha feita do passo1 no input do passo 2
                let orderChose = parseInt($(this).attr('data-order')) + 1;
                orderChose = orderChose.toString();
                $('.contentStep3').each(function() {
                    let arrayChoose = $(this).find('.choose_step_1').val().trim().replaceAll(' ', '').split(',');
                    const arrayContains = (arrayChoose.indexOf(orderChose) > -1);
                    if(arrayContains){
                        $(this).addClass('hide');
                    }
                });
                custom.calcTotalPrice(paginationCustom);
            });

            //Passo 3
            $('.contentStep3').on("click", function() {
                //atualiza preço passo 3

                $('a.btnBack').addClass('is-hidden')
                $('a.backToStep3').removeClass('is-hidden');

                let priceStep3 = $(this).find('.priceCustom').attr('data-price');

                if(priceStep3 != '' && priceStep3 != '0'){
                    if( paginationCustom == 3 ){
                        $('.custom_buy .step3 .step3Selected .price').html(formatDiscountPrice(false, Number(priceStep3)));
                        $('.custom_buy .step3 .step3Selected .price').attr('data-price', priceStep3);
                    } else if( paginationCustom == 4 ){
                        $('.custom_buy .step4 .step3Selected .price').html(formatDiscountPrice(false, Number(priceStep3)));
                        $('.custom_buy .step4 .step3Selected .price').attr('data-price', priceStep3);
                    }
                }else{
                    if( paginationCustom == 3 ){
                        $('.custom_buy .step3 .step3Selected .price').text('Grátis');
                        $('.custom_buy .step3 .step3Selected .price').attr('data-price', 0);
                    } else if( paginationCustom == 4 ){
                        $('.custom_buy .step4 .step3Selected .price').text('Grátis');
                        $('.custom_buy .step4 .step3Selected .price').attr('data-price', 0);
                    }
                }

                //atualiza texto passo 4
                const textClick = $(this).find('.text_button').text().trim();
                $('.step3Selected .choice').text(textClick)

                 //avança passo 4
                $(this).siblings('div').removeClass('active');
                $(this).addClass('active');
                $(this).parent().hide();

                if( paginationCustom == 3 ){
                    $('.custom_buy .step3').show();
                    custom.activeStepAccordion(3);
                    $('.custom_buy .step3').addClass('active');
                } else if( paginationCustom == 4 ){
                    $('.custom_buy .step4').show();
                    custom.activeStepAccordion(4);
                    $('.custom_buy .step4').addClass('active');
                }

                // $('.paginationCustom li[data-slide="3"]').removeClass('active');
                if( paginationCustom == 3 ){
                    $('.paginationCustom li:nth-child(3)').addClass('active');
                    custom.activeStepBar(3);
                } else if( paginationCustom == 4 ){
                    $('.paginationCustom li:nth-child(4)').addClass('active');
                    custom.activeStepBar(4);
                }

                //add variantID botão btnAddCartCustom
                $('.btnAddCartCustom').attr('data-step3id',  $(this).find('.priceCustom').attr('data-variantid'))
                $('.btnAddCartCustom').attr('data-step3prop',  $(this).find('.text_button').text().trim())


                custom.calcTotalPrice(paginationCustom);
            });
        },
        addCustomCart(){
            $('.btnAddCartCustom').on("click", function() {

                var randomNumber = Math.floor(Math.random() * (99999 - 10000) + 10000);
                var thisVariantId = $('.btnAddCartCustom').attr('data-productid');
                $('.custom_buy').addClass('loading');
                $.ajax({
                    type: 'GET',
                    url: '/cart.json',
                    success: function(response) {
                        var isIdContent = false;
                        if(response && response.items && response.items.length > 0){
                            for (let i = 0; i < response.items.length; i++) {
                                if (thisVariantId == response.items[i].id){
                                    isIdContent = true;
                                }
                            }
                        }
                        if(isIdContent){
                            // Swal.fire({
                            //     icon: 'error',
                            //     html: '<strong>O produto que você está tentando personalizar já existe no seu carrinho</strong><br /><p>Deseja ir para o carrinho alterar a quantidade ou excluir?</p>',
                            //     confirmButtonText: 'Ir para o carrinho',
                            //     showDenyButton: false,
                            //     showCancelButton: true,
                            //     cancelButtonText: `Cancelar`,
                            // }).then((result) => {
                            //     if (result.isConfirmed) {
                            //         window.location.href = "/cart";
                            //     }
                            // });
                            alert('O produto que você está tentando personalizar já existe no seu carrinho!')
                            $('.custom_buy').removeClass('loading');
                        }else{
                            //monta obj post
                            let items = [];
                            let property = '';

                            //produto principal
                            items.push({
                                quantity: 1,
                                id: parseInt(thisVariantId),
                                properties: {
                                    'custom': 'true'
                                    //'idAddCart': randomNumber
                                }
                            });

                            //produto brinde - kitlimpeza
                            if($('.addCartCustom .btnAddCartCustom').attr('data-kitfree') != ''){
                                items.push({
                                    quantity: 1,
                                    id: parseInt($('.addCartCustom .btnAddCartCustom').attr('data-kitfree')),
                                    properties: {
                                        //'custom': 'brinde',
                                        'mainProduct': parseInt($('.btnAddCartCustom').attr('data-productid'))
                                        //'idAddCart': randomNumber
                                    }
                                });
                            }

                            //produto step1
                            if($('.btnAddCartCustom').attr('data-step1id')){
                                if($('.btnAddCartCustom').attr('data-step1id') != ''){
                                    items.push({
                                        quantity: 1,
                                        id: parseInt($('.btnAddCartCustom').attr('data-step1id')),
                                        properties: {
                                            //'custom': $('.btnAddCartCustom').attr('data-step1prop'),
                                            'mainProduct': parseInt($('.btnAddCartCustom').attr('data-productid'))
                                            //'idAddCart': randomNumber
                                        }
                                    });
                                }else{
                                    items[0].properties.custom = $('.btnAddCartCustom').attr('data-step1prop');
                                }
                            }

                            //produto step2
                            if($('.btnAddCartCustom').attr('data-step2id')){
                                if($('.btnAddCartCustom').attr('data-step2id') != ''){
                                    items.push({
                                        quantity: 1,
                                        id: parseInt($('.btnAddCartCustom').attr('data-step2id')),
                                        properties: {
                                            //'custom': $('.btnAddCartCustom').attr('data-step2prop'),
                                            'mainProduct': parseInt($('.btnAddCartCustom').attr('data-productid'))
                                            //'idAddCart': randomNumber
                                        }
                                    });
                                }else{
                                    items[0].properties.custom = items[0].properties.custom + ' | ' + $('.btnAddCartCustom').attr('data-step2prop');
                                }
                            }

                            //produto step3
                            if($('.btnAddCartCustom').attr('data-step3id')){
                                if($('.btnAddCartCustom').attr('data-step3id') != ''){
                                    items.push({
                                        quantity: 1,
                                        id: parseInt($('.btnAddCartCustom').attr('data-step3id')),
                                        properties: {
                                            //'custom': $('.btnAddCartCustom').attr('data-step2prop'),
                                            'mainProduct': parseInt($('.btnAddCartCustom').attr('data-productid'))
                                            //'idAddCart': randomNumber
                                        }
                                    });
                                }else{
                                    items[0].properties.custom = items[0].properties.custom + ' | ' + $('.btnAddCartCustom').attr('data-step3prop');
                                }
                            }


                            $.ajax({
                                type: "POST",
                                url: '/cart/add.js',
                                dataType: 'json',
                                data: { items },
                                    success: function(result) {
                                        console.log(result)
                                        window.location.href = "/cart";
                                        $('.custom_buy').removeClass('loading');
                                    },
                                    error: function(error) {
                                        console.log(error)
                                        if(error.responseJSON.status == 422){
                                            alert('Ops, alguns dos produtos estão sem estoque.');
                                            $('.custom_buy').removeClass('loading');
                                        }else{
                                            alert('Não foi possível adicionar o produto ao carrinho tente novamente mais tarde');
                                            console.log('error', error)
                                            $('.custom_buy').removeClass('loading');
                                        }
                                    }
                            });
                        }
                    }
                });


                return false;
            });
        },
        removeItemCartCustom(){
            let dataUpdate = { updates: [] }

            $('.removeCustom').on("click", function() {
                $('.line-item-table').addClass('loading');
                $(this).closest('tr').addClass('currentMinus');

                let qtdCurrentItem = parseInt($(this).parent().find('.quantity-selector__input').val());
                qtdCurrentItem = qtdCurrentItem - 1;
                const currentId = parseInt($(this).attr('data-variantid'));

                $('tr.line-item').each(function() {

                    if(currentId == $(this).attr('data-mainvairiantid')){
                        dataUpdate.updates.push(0)
                    }
                    else if($(this).hasClass('currentMinus')){
                        dataUpdate.updates.push(0)
                    }
                    else{
                        dataUpdate.updates.push($(this).find('.quantity-selector__input').val())
                    }
                });

                $.ajax({
                    type: 'POST',
                    url: '/cart/update.js',
                    data: dataUpdate,
                    success: function() {
                        document.location.reload(true);
                    },
                    error: function(error){
                        $('.line-item-table').removeClass('loading');
                        console.log(error);
                        alert('Erro ao adicionar produto.')
                    }
                });
                return false;
            });
        },
        plusItemCartCustom(){

            let newData = {
                "items": []
            }

            $('.plusCustom').on("click", function() {
                $('.line-item-table').addClass('loading');
                var thisClick = $(this);
                let qtdCurrentItem = parseInt($(this).parent().find('.quantity-selector__input').val());
                qtdCurrentItem = qtdCurrentItem + 1;

                const currentId = parseInt($(this).attr('data-variantid'));
                $('tr.line-item').each(function() {
                    if(currentId == $(this).attr('data-mainvairiantid')){

                        //add produtos customizados
                        newData.items.push(
                        {
                            "id": $(this).attr('data-variantid'),
                            "quantity": 1,
                            "properties" : {
                              "mainProduct": currentId
                            }
                        })

                    }
                });

                //add produtos atual
                 newData.items.push(
                {
                    "id": currentId,
                    "quantity": 1,
                    "properties" : {
                        "custom": thisClick.closest('tr').find('.line-item__property').text().split(':')[1].trim()
                    }
                })
                $.ajax({
                    type: 'POST',
                    url: '/cart/add.js',
                    data: newData,
                    dataType: 'json',
                    success: function() {
                        document.location.reload(true);
                    },
                    error: function(error){
                        $('.line-item-table').removeClass('loading');
                        console.log(error);
                        alert('Erro ao adicionar produto.')
                    }
                });
            });
        },
        minusItemCartCustom(){
            let dataUpdate = { updates: [] }

            $('.minusCustom').on("click", function() {
                $('.line-item-table').addClass('loading');
                $(this).closest('tr').addClass('currentMinus');
                let qtdCurrentItem = parseInt($(this).parent().find('.quantity-selector__input').val());
                qtdCurrentItem = qtdCurrentItem - 1;
                const currentId = parseInt($(this).attr('data-variantid'));

                var qtdMinus = 0;
                $('tr.line-item').each(function() {
                    qtdMinus = parseInt($(this).find('.quantity-selector__input').val()) - 1;
                    if(currentId == $(this).attr('data-mainvairiantid')){
                        dataUpdate.updates.push(qtdMinus)
                    }
                    else if($(this).hasClass('currentMinus')){
                        dataUpdate.updates.push(qtdMinus)
                    }
                    else{
                        dataUpdate.updates.push($(this).find('.quantity-selector__input').val())
                    }
                });

                $.ajax({
                    type: 'POST',
                    url: '/cart/update.js',
                    data: dataUpdate,
                    success: function() {
                        document.location.reload(true);
                    },
                    error: function(error){
                        $('.line-item-table').removeClass('loading');
                        console.log(error);
                        alert('Erro ao adicionar produto.')
                    }
                });
            });
        },
        cleanCart(){
            $('.clearCart').on("click", function() {
                $.ajax({
                    type: 'GET',
                    url: '/cart/clear.js',
                    success: function() {
                        document.location.reload(true);
                    }
                });
            });
        },
        addCartNoCustom(){
            $('#AddToCartNoCustom').on("click", function() {
                var currentVarId = $('input[name="id"]').val();
                $.ajax({
                    type: 'GET',
                    url: '/cart.json',
                    success: function(response) {
                        var isIdContent = false;
                        if(response.items.length){
                            for (let i = 0; i < response.items.length; i++) {
                                if (currentVarId == response.items[i].id){
                                    isIdContent = true;
                                }
                            }
                        }
                        if(isIdContent){
                            Swal.fire({
                                icon: 'error',
                                html: '<strong>O produto que você está tentando adicionar já existe no seu carrinho</strong><br /><p>Deseja ir para o carrinho alterar a quantidade ou excluir?</p>',
                                confirmButtonText: 'Ir para o carrinho',
                                showDenyButton: false,
                                showCancelButton: true,
                                cancelButtonText: `Cancelar`,
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    window.location.href = "/cart";
                                }
                            });
                        }else{
                            var items = [];
                            items.push({
                                quantity: '1',
                                id: parseInt(currentVarId)
                                //properties: { property }
                            });
                            $.ajax({
                                type: "POST",
                                url: '/cart/add.js',
                                    dataType: 'json',
                                    data: { items },
                                        success: function(result) {
                                           //document.location.reload(true);
                                           window.location.href = "/cart";
                                        },
                                    error: function(error) {
                                        console.log(error)
                                    }
                            });
                        }
                    }
                });
                return false;
            });
        },
        getKitVariantId(){
            if($('.addCartCustom .btnAddCartCustom').length > 0){
                if($('.addCartCustom .btnAddCartCustom').attr('data-kitfree') != ''){
                    var handleKit = $('.addCartCustom .btnAddCartCustom').attr('data-kitfree');
                    $.getJSON('/products/'+handleKit+'.js', function(product) {
                        var variantIdKit = product.variants[0].id;
                        $('.addCartCustom .btnAddCartCustom').attr('data-kitfree', variantIdKit);
                    });
                }
            }
        },
        agrupamentoVariantsTags(){
            if($('.groupTags').length){
                let arrayTags = '';
                if($('.groupTags').val().indexOf('|') > -1){
                    arrayTags = $('.groupTags').val().split('|')
                }else{
                    arrayTags = $('.groupTags').val();
                }
                for (let i = 0; i < arrayTags.length; i++) {
                    $.getJSON('/products/'+arrayTags[i]+'.js', function(product) {

                        let urlProd = '//'+Shopify.shop+'/products/' + arrayTags[i];
                        let imgVariant0 = product.variants[0].title.replaceAll(' ', '_');

                        let urlThemeImg = $('.header__logo img').attr('src').split('files/');
                        urlThemeImg = urlThemeImg[0]+'files/' + urlThemeImg[1]+'files/';
                        urlThemeImg = urlThemeImg + imgVariant0 + '_72x72.png';

                        let isDisabled = '';
                        if( !product.available ){
                            isDisabled = 'is-disabled'
                        }

                        $('.product__info .color-swatch-list').append(`
                            <div class="color-swatch ${isDisabled}">
                                <a href="`+urlProd+`" title="`+product.variants[0].title+`" class="color-swatch__item variantJs" style="background-image: url(`+urlThemeImg+`)">
                                <span class="visually-hidden">`+product.variants[0].title+`</span>
                                </a>
                            </div>
                        `)

                        $('.product-sticky-form__variants .select-wrapper').append(`
                            <div class="color-swatch-sticky ">
                                <a href="`+urlProd+`" title="`+product.variants[0].title+`" class="color-swatch__item variantJs">
                                <span class="imgVariant" style="background-image: url(`+urlThemeImg+`)"></span>
                                <span class="visually-text">`+product.variants[0].title+`</span>
                                </a>
                            </div>
                        `);

                        //hover
                        $('.color-swatch-list .color-swatch a.variantJs').off();
                        $('.color-swatch-list .color-swatch a.variantJs').mouseenter(function() {
                            var currentTitle = $(this).attr('title');
                            $('.product-form__option-value').hide();
                            $('.product-form__option-value').after('<span class="product-form__option-value newTitleAdd">'+currentTitle+'</span>')
                        });
                        $('.color-swatch-list .color-swatch a.variantJs').mouseleave(function() {
                            $('.product-form__option-value').show();
                            $('.product-form__option-value.newTitleAdd').remove();
                        });
                    });
                }
            }
        },
        backToStep(){
            $('.custom_buy .btnBack').on("click", function() {
                if($(this).hasClass('backToStep1')){
                    $('.custom_buy .step2, .custom_buy .step3, .custom_buy .step4').hide();
                    $('.custom_buy .step2, .custom_buy .step3, .custom_buy .step4').removeClass('active');
                    $('.custom_buy .step1').show();
                    custom.activeStepAccordion(1);
                    $('.custom_buy .step1').addClass('active');
                    $('.paginationCustom li').not('[data-slide="1"]').removeClass('active');
                    $('a.btnBack').addClass('is-hidden')
                    // $('.paginationCustom li:nth-child(1)').addClass('active');
                    custom.activeStepBar(1);
                }
                if($(this).hasClass('backToStep2')){
                    $('.custom_buy .step1, .custom_buy .step3, .custom_buy .step4').hide();
                    $('.custom_buy .step1, .custom_buy .step3, .custom_buy .step4').removeClass('active');
                    $('.custom_buy .step2').show();
                    custom.activeStepAccordion(2);
                    $('.custom_buy .step2').addClass('active');
                    $('.paginationCustom li').not('[data-slide="2"], [data-slide="1"]').removeClass('active');
                    $('a.btnBack').addClass('is-hidden');
                    $('.btnBack.backToStep1').removeClass('is-hidden')
                    // $('.paginationCustom li:nth-child(2)').addClass('active');
                    custom.activeStepBar(2);
                }
                if($(this).hasClass('backToStep3')){
                    $('.custom_buy .step1, .custom_buy .step2, .custom_buy .step4').hide();
                    $('.custom_buy .step1, .custom_buy .step2, .custom_buy .step4').removeClass('active');
                    $('.custom_buy .step3').show();
                    custom.activeStepAccordion(3);
                    $('.custom_buy .step3').addClass('active');
                    $('.paginationCustom li').not('[data-slide="3"], [data-slide="2"], [data-slide="1"]').removeClass('active');
                    $('a.btnBack').addClass('is-hidden')
                    $('.btnBack.backToStep2').removeClass('is-hidden')
                    // $('.paginationCustom li:nth-child(3)').addClass('active');
                    custom.activeStepBar(3);
                }

                return false;
            });

        },
        checkVariantStick(){
            $('.product-sticky-form__form .combo-box').on('DOMSubtreeModified', function(e) {
                setTimeout(() => {
                    if($('.product-sticky-form__form .combo-box').attr('open') == 'open'){
                        $('.product-sticky-form__form .select-wrapper .color-swatch-sticky').show();
                    }else{
                        $('.product-sticky-form__form .select-wrapper .color-swatch-sticky').hide();
                    }
                }, 150)
            });
        },
        checkColorPrice: () => {
            document.querySelectorAll('.product-item-meta__swatch-list .color-swatch').forEach(function(swatch) {
               
                swatch.addEventListener('click', function() {
                    debugger;
                    const variantHandle = swatch.dataset.handle;
        
                    fetch(`/products/${variantHandle}.js`)
                        .then(response => response.json())
                        .then(productData => {
                            const variantTitle = swatch.dataset.title;
                            const variant = productData.variants.find(v => v.title === variantTitle);
        
                            if (variant) {
                                const parentItem = swatch.closest('.product-item');
                                const finalPriceDiv = parentItem.querySelector('.price.price--highlight');
                                const comparePriceDiv = parentItem.querySelector('.price.price--compare');
                                const parcelatorDiv = parentItem.querySelector('.parcelatorCollection');
        
                                // Atualiza o preço principal
                                if (finalPriceDiv) {
                                    finalPriceDiv.textContent = `R$ ${(variant.price / 100).toFixed(2).replace(".", ",")}`;
                                }
        
                                // Atualiza o preço comparativo, se existir
                                if (comparePriceDiv) {
                                    if (variant.compare_at_price) {
                                        comparePriceDiv.textContent = `R$ ${(variant.compare_at_price / 100).toFixed(2).replace(".", ",")}`;
                                    } else {
                                        comparePriceDiv.textContent = '';
                                    }
                                }
        
                                // Atualiza o valor do parcelamento, se existir
                                if (parcelatorDiv) {
                                    const parcela = (variant.price / 100 / 6).toFixed(2).replace(".", ",");
                                    parcelatorDiv.innerHTML = `<p><strong>6X</strong> <strong>R$&nbsp;${parcela}</strong> sem juros</p>`;
                                }
                            } else {
                                console.error('Variante não encontrada!');
                            }
                        })
                        .catch(error => console.error('Erro ao buscar a variante:', error));
                });
            });
        },            
        imageSelectedInProductCaroselVertical:()=>{
            if(window.matchMedia("(min-width: 768px)").matches){
                let urlAbsolute = '';
                $('.product__thumbnail-item').each(function(){

                    if( $(this).attr('aria-current') ){
                        urlAbsolute = $(this).find('img').attr('src')
                        custom.addImageInModalChoicePageProduct( urlAbsolute )
                        return false
                    }
                })
            }

        },
        addImageInModalChoicePageProduct: ( urlImageProduct )=>{
            $('.product__thumbnail-item').each(function(){
                if( $(this).attr('aria-current') ){
                    urlAbsolute = $(this).find('img').attr('src')
                    console.log('---> ', urlImageProduct)
                }
            })

            let regexPrefixURL = /([^\/]*)$/;
            let regexNameProduct = /(^.+products)/;
            let regexNameProductWithOutSize =  /_([^_]*)$/g;
            if(urlImageProduct.indexOf('/products/') === -1)  {
                regexNameProduct = /(^.+files)/;
            }

            // urlImageProduct = 'https://cdn.shopify.com/s/files/1/0548/8168/1460/products/Lahtref-581-3_800x.png?v=1666782811';
            let urlPrefix = urlImageProduct.replace(regexPrefixURL, '');
            let urlNameProduct = urlImageProduct.replace(regexNameProduct, '');
            let nameProduct = urlNameProduct.replace(regexNameProductWithOutSize, '')

            let newSizeToImage = `${nameProduct}_1080x`;
            let newUrl = `${urlPrefix}${newSizeToImage}.png`;
            const selectModel = $('.product-form__option-value')[0] ? `<small>${$('.product-form__option-value').text()}</small>` : '';

            if ( $('.nem-imagem-modal').length > 0 ) {
                $('.nem-imagem-modal__image').attr('style', ` background-image:url('${newUrl}') `)
                $('.nem-imagem-modal').addClass('is-active')
                // $('.loading-modal').addClass('is-active')
                custom.insertImage(newUrl);
                $('.modal-product-name').html(`${$('.product-meta__title').text()} ${selectModel}`);

            } else{
                let countChildrenInBody = $('body').children().length -1;
                $('body').children().eq(countChildrenInBody).after(`
                    <div class="nem-imagem-modal is-active">
                        <span class="modal-product-name">${$('.product-meta__title').text()} ${selectModel}</span>
                        <div class="nem-imagem-modal__container">
                            <div class="nem-imagem-modal__content">
                                <div class="nem-imagem-modal__image" style="background-image:url('${newUrl}')"></div>
                            </div>
                        </div>
                    </div>
                `)
            }

            custom.insertImage(newUrl)
            setTimeout(()=>{
                $('.loading-modal').removeClass('is-active')
            }, 1000)

        },
        removeModalwithImage: ()=>{
            $('.nem-imagem-modal').remove()
            // $('.custom_buy').removeClass('active');
            $('body').removeClass('hidden-scroll');

            $('#shopify-section-announcement-bar').removeClass('is-hidden')
            $('#shopify-section-header').removeClass('is-hidden')

            $('shopify-section--announcement-bar').removeClass('custom-buy_active');
            $('.shopify-section--header').removeClass('custom-buy_active');
            $('#shopify-section-announcement-bar').removeClass('custom-buy_active');
        },
        openModalWihtImage:()=>{
            $('body').addClass('hidden-scroll')
            $('#shopify-section-announcement-bar').addClass('is-hidden')
            $('#shopify-section-header').addClass('is-hidden');

            window.matchMedia("(min-width: 768px)").matches && $('.loading-modal').addClass('is-active');

            custom.imageSelectedInProductCaroselVertical();

        },
        insertImage:( url )=>{
            $('.nem-imagem-modal__image').attr('style', ` background-image:url('${url}') `)
            $('.nem-imagem-modal').addClass('is-active')
        }
    }

    if( $('.custom_buy').hasClass('active') ){
        custom.openModalWihtImage()
    } else{
        custom.removeModalwithImage();
    }

    $(window).on('resize',function() {
        let viewportWidth = $(window).width();
        let time = 600

        if (viewportWidth < 767) {
            setTimeout(()=>{
                if( $('.custom_buy').hasClass('active') ) custom.removeModalwithImage()
            }, time)
        } else {
            setTimeout(()=>{
                if( $('.custom_buy').hasClass('active') ) custom.openModalWihtImage();
            }, time)
        }
    });

    $(document).on('click', '.js-openImage', function( { target } ){
        $(target).toggleClass('is-active')
        $(target).parents('.footer-metafield__container').find('.footer-metafield__paragraph').toggleClass('is-active')
    })

    // if( $('body').find('.hidden-product').length > 0 ) $('body').find('.hidden-product').closest('product-item').hide();

    //invoke functions
    custom.closeCustomLens();
    custom.openCustomLens();
    custom.getPriceHandle();
    custom.selectCustom();
    custom.addCustomCart();
    custom.removeItemCartCustom();
    custom.plusItemCartCustom();
    custom.minusItemCartCustom();
    custom.cleanCart();
    custom.addCartNoCustom();
    custom.getKitVariantId();
    custom.agrupamentoVariantsTags();
    custom.backToStep();
    custom.checkVariantStick();
    custom.checkColorPrice();

});

const initCollectionImages = setInterval(() => {
    if (typeof $ === 'function'){
        clearInterval(initCollectionImages);
        if($('[data-desk-break-images]')[0]){
            desktopBreakImages();
        }
        if($('[data-mobile-phrases]')[0]){
            mobileBreakPrhases();
        }
    }
}, 500);

const customProductDetail = () => {
    $('.product-form__variants').before($('.product-meta__title'));
    $('.product-form__variants').after($('.product-meta'));
    const intervalReview = setInterval(() => {
        if($('a[href="#looxReviews"]')[0]){
            clearInterval(intervalReview);
            $('.product-form__buy-buttons').after($('a[href="#looxReviews"]').parents('.shopify-app-block'));
        }
    }, 500)

}

const intervalInitJquery = setInterval(() => {
    if (typeof $ === 'function'){
        clearInterval(intervalInitJquery);
        if($('.custom-product-detail')[0]){
            customProductDetail();
        }
    }
}, 500)